module.exports = __webpack_public_path__ + "img/fernandaaguirre.e9c7659e.jpg";